import {ApiSystemModuleResult} from "app/Interface/Api/System/ApiSystemModule"
import {ModuleIcons} from "app/WebController/Header/Navigation/NavIcons"
import cls from "classnames"
import Logger from "logger/logger"
import React, {createElement, useEffect} from "react"
import {useTranslation} from "react-i18next"
import {Link} from "react-router-dom"

interface SystemModuleNavigationItemProps {
  module: SystemModuleNavigationModule
}

export interface SystemModuleNavigationModule extends ApiSystemModuleResult {
  icon: any
  active: boolean
}

function SystemModuleNavigationItem({module}: SystemModuleNavigationItemProps) {
  const {t} = useTranslation('Module.Modules')
  const LinkStyle = {
    display: 'flex',
    alignItems: 'center',
  }

  useEffect(() => {
    Logger('Element.Navigation.Module.item.init')
    return () => {
      Logger('Element.Navigation.Module.item.unloading')
    }
  }, [])

  return (
    <Link
      to={module.path === '/' ? module.path : `/${module.path}`}
      style={LinkStyle}
      className={cls('nav-item', module.name, {'active': module.active})}
    >
      {ModuleIcons[module.name] && createElement(ModuleIcons[module.name], {
        id: module.id,
        wrapper: 'span',
        onClick: () => null,
        active: module.active,
        variant: 'primary',
      })}
      <span className={`name`}>{t(module.name)}</span>
    </Link>
  )
}

export default SystemModuleNavigationItem
